﻿/*
 * Globalize Culture de-DE
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("de-DE", "default", {
    name: "de-DE",
    englishName: "German (Germany)",
    nativeName: "Deutsch (Deutschland)",
    language: "de",
    numberFormat: {
      ",": ".",
      ".": ",",
      NaN: "n. def.",
      negativeInfinity: "-unendlich",
      positiveInfinity: "+unendlich",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
          ],
          namesAbbr: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          namesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
        },
        months: {
          names: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
            ""
          ],
          namesAbbr: [
            "Jan",
            "Feb",
            "Mrz",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez",
            ""
          ]
        },
        AM: null,
        PM: null,
        eras: [{ name: "n. Chr.", start: null, offset: 0 }],
        patterns: {
          d: "dd.MM.yyyy",
          D: "dddd, d. MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dddd, d. MMMM yyyy HH:mm",
          F: "dddd, d. MMMM yyyy HH:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Zusätzliche Hilfe",
      AddNewTab: "Neues Register hinzufügen",
      Alerts: "Alarmmeldungen",
      ApplyFilter: "Filter anwenden",
      Approve: "Genehmigen",
      Attachments: "Anhänge",
      Back: "Zurück",
      Basic: "Einfach",
      Between: "Zwischen",
      Book: "Buch",
      Cancel: "Abbrechen",
      Checked: "Markiert",
      ClearFilter: "Filter löschen",
      Close: "Schließen",
      CloseCancelChanges: "Schließen und Änderungen verwerfen",
      CloseSaveChanges: "Schließen und Änderungen speichern",
      CloseTab: "Register schließen",
      ColumnPersonalization: "Spaltenpersonalisierung",
      Comments: "Anmerkungen",
      Confirmation: "Bestätigung",
      Contains: "Enthält",
      CreateTab: "Neues Register erstellen",
      Cut: "Ausschneiden",
      Delete: "Löschen",
      DiscardUndo: "Verwerfen/Rückgängig machen",
      DisplayDropDownList: "Dropdownliste anzeigen",
      Displaying: "Anzeige: ",
      DocWord: "Dokument",
      DoesNotContain: "Enthält nicht",
      DoesNotEndWith: "Endet nicht mit",
      DoesNotEqual: "Ungleich",
      DoesNotStartWith: "Beginnt nicht mit",
      Download: "Herunterladen",
      Duplicate: "Kopieren",
      Edit: "Bearbeiten",
      EitherSelectedorNotSelected: "Ausgewählt/Nicht ausgewählt",
      Email: "E-Mail",
      EndsWith: "Endet mit",
      EqualsStr: "Gleich",
      ExpandCollapse: "Einblenden/Ausblenden",
      ExportFailed: "Fehler bei Export",
      ExportToExcel: "Export nach Excel",
      FileInUse: "Angegebene Datei wird verwendet",
      FileInUseDetail:
        "Schließen Sie die Datei in der Anwendung, in der sie verwendet wird, oder geben Sie einen anderen Dateinamen ein.",
      Filter: "Filter",
      FilterMenu: "Filtermenü",
      FilterOptions: "Filteroptionen",
      FilterWithinResults: "Ergebnisse filtern",
      First: "Erster Wert",
      FirstView: "Erste Ansicht",
      Folder: "Ordner",
      ForgotPassword: "Kennwort vergessen?",
      Forward: "Vorwärts",
      GetMoreRows: "Weitere Zeilen anzeigen",
      GreaterThan: "Größer als",
      GreaterThanOrEquals: "Größer als oder gleich",
      GridSettings: "Rastereinstellungen",
      GroupSelection: "Gruppenauswahl",
      Help: "Hilfe",
      HideColumn: "Spalte ausblenden",
      IsEmpty: "Ist leer",
      IsNotEmpty: "Ist nicht leer",
      Last: "Letzter Wert",
      LastView: "Letzte Ansicht",
      LaunchActivate: "Starten/Aktivieren",
      LessThan: "Kleiner als",
      LessThanOrEquals: "Kleiner als oder gleich",
      Links: "Verknüpfungen",
      ListTabs: "Alle Register auflisten",
      LoadingItem: "Lade Objekt  ",
      Maintenance: "Verwaltung",
      Menu: "Menü",
      New: "Neu",
      Next: "Weiter",
      NextView: "Nächste Ansicht",
      No: "Nein",
      NotChecked: "Nicht markiert",
      Notes: "Kommentare",
      NotSelected: "Nicht ausgewählt",
      Of: " von ",
      Ok: "OK",
      Open: "Öffnen",
      Password: "Kennwort",
      Paste: "Einfügen",
      Phone: "Telefon",
      PleaseWait: "Bitte warten",
      Previous: "Zurück",
      PreviousView: "Vorherige Ansicht",
      Print: "Drucken",
      Queries: "Abfragen",
      Redo: "Wiederherstellen",
      Refresh: "Aktualisieren",
      Reject: "Ablehnen",
      RememberMe: "Login auf diesem Computer speichern",
      Reports: "Berichte",
      Reset: "Zurücksetzen",
      Review: "Überprüfen",
      RunFilter: "Filter ausführen",
      RunJob: "Job ausführen",
      Save: "Speichern",
      SaveBeforeClosing: "Vor dem Schließen speichern",
      SavedFilters: "Gespeicherte Filter",
      SaveSubmit: "Speichern/Übermitteln",
      ScreenDesign: "Bildschirmgestaltung",
      Search: "Suchen",
      SelectContents: "Inhalt auswählen",
      SelectDate: "Datum auswählen",
      SelectDeselect: "Alle auswählen/Auswahl für alle aufheben",
      Selected: "Ausgewählt: ",
      ServerName: "Server-Name",
      Settings: "Einstellungen",
      ShowFilterRow: "Filterzeile anzeigen",
      SignIn: "Anmelden",
      SortAscending: "Aufsteigend sortieren",
      SortDescending: "Absteigend sortieren",
      Spreadsheet: "Tabelle",
      StartsWith: "Beginnt mit",
      StatusIndicator: "Statusanzeige",
      Tasks: "Aufgaben",
      Today: "Heute",
      Translate: "Übersetzen",
      UserID: "Benutzer-ID",
      Utilities: "Dienstprogramme",
      Yes: "Ja",
      Page: "Seite",
      Rows: "Zeilen",
      ShowingAll: "Alle anzeigen",
      SessionNavigation: "Sitzungsnavigation",
      ListAllMenuItems: "Alle Menüoptionen auflisten",
      NoRecordsFound: "Keine Datensätze gefunden",
      SearchTree: "Hierarchie durchsuchen",
      Clear: "Löschen",
      DrillDown: "Drill-Down",
      Required: "Dieses Feld ist obligatorisch.",
      Available: "Verfügbar:",
      Add: "Hinzufügen",
      MoveDown: "Nach unten",
      MoveUp: "Nach oben",
      Remove: "Entfernen",
      LastYear: "Letztes Jahr",
      NextMonth: "Nächster Monat",
      NextWeek: "Nächste Woche",
      NextYear: "Nächstes Jahr",
      OneMonthAgo: "Vor einem Monat",
      OneWeekAgo: "Vor einer Woche",
      SixMonthsAgo: "Vor sechs Monaten",
      Time: "Zeit",
      CannotBeSelected: "Diese Zeile kann nicht ausgewählt werden.",
      ResetToDefault: "Auf Standardlayout zurücksetzen",
      CloseOtherTabs: "Andere Registerkarten schließen",
      EmailValidation: "Gültige E-Mail-Adresse eingeben",
      UrlValidation: "Gültige URL eingeben",
      EndofResults: "Ende der Ergebnisse",
      More: "Mehr...",
      RecordsPerPage: "Datensätze pro Seite",
      Maximize: "Maximieren",
      Minimize: "Minimieren",
      CloseAllTabs: "Alle Registerkarten schließen",
      QuickDates: "Datumsoptionen",
      Finish: "Fertig stellen",
      SetTextColor: "Farbe für Text festlegen",
      AttachmentRules: "Regeln für Anhänge",
      AutoRefresh: "Automatisch aktualisieren",
      BarChart: "Balkendiagramm",
      CopyMail: "Kopieren und per E-Mail senden",
      CopyUrl: "URL kopieren",
      DistributeHorizontally: "Horizontal verteilen",
      ExpandAll: "Alle erweitern",
      Generate: "Generieren",
      GenerateScript: "Skript generieren",
      NoAttachments: "Keine Anhänge",
      PieChart: "Kreisdiagramm",
      QuickAccess: "Schnellzugriff",
      RestoreUser: "Benutzerdaten wiederherstellen",
      SaveConsolidate: "Mit lokaler Konsolidierung speichern",
      "Screen Design": "Bildschirmgestaltung",
      SelectAll: "Alle auswählen",
      SpellCheck: "Rechtschreibprüfung",
      SubmitForApproval: "Zur Genehmigung absenden",
      TopDownSpread: "Top Down Spread",
      Timezone: "Zeitzone",
      Loading: "Laden...",
      NewNode: "Neuer Knoten"
    }
  });
})(this);
